
import React from 'react';
import { cn } from "@/lib/utils";
import { motion, HTMLMotionProps } from "framer-motion";

interface FlatDashboardCardProps extends Omit<HTMLMotionProps<"div">, "animate" | "initial" | "transition" | "whileHover"> {
  children: React.ReactNode;
  className?: string;
}

const FlatDashboardCard = ({ children, className, ...props }: FlatDashboardCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className={cn(
        "relative rounded-3xl overflow-hidden p-6",
        "group transition-all duration-300",
        className
      )}
      {...props}
    >
      {/* Base Gradient (Bottom Layer) */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-white/60 via-white/30 to-white/10 dark:from-black/40 dark:to-black/20" />
      
      {/* Top border highlight */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-300/30 to-transparent dark:via-amber-500/20" />
      
      {/* Glass effect */}
      <div className="absolute inset-0 backdrop-blur-xl backdrop-saturate-150 -z-10" />
      
      {/* Content */}
      <div className="relative">
        {children}
      </div>
    </motion.div>
  );
};

export default FlatDashboardCard;
